export const spotHouseVersion = {
    // map address spothouse => abi version name
    // v2 default, and for stable pairs, new bonds, etc
    "0xfc7272905e92f00e90cf3df0b6f95a25230bd86c": "v2",
    // V1 for old bonds
    "0xa62c140cbc89aca814f0dbd81fd3fd853083125a": "v1"
}